import React, { useContext, useState } from "react";
import styles from "./HelpVIdeoCard.module.css";
import { isEmpty } from "lodash";
import Context from "../../context/Context";
import SingleVideoPlayer from "../SingleVideoPlayer/SingleVideoPlayer";

export default function HelpVIdeoCard({ contestDetails }) {
  const { details } = useContext(Context);
  const [howToParticipatePopup, setHowToParticipatePopup] = useState(false);
  const [howToParticipateVideo, setHowToParticipateVideo] = useState("");

  return (
    <div className="w-full">
      {howToParticipatePopup && (
        <SingleVideoPlayer
          setHowToParticipatePopup={setHowToParticipatePopup}
          fileUrl={howToParticipateVideo}
          heading="How To Participate"
        />
      )}
      {!details?.howToParticipate?.hideHowToParticipate &&
        (isEmpty(details?.howToParticipate?.files) ? (
          <div
            className={styles.howToParticipateCard}
            onClick={() => {
              setHowToParticipatePopup(true);
              setHowToParticipateVideo(details?.howToParticipate?.fileUrl);
            }}
          >
            <div className="w-[40px] h-[40px] shrink-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                className="w-full h-full"
              >
                <circle
                  cx="22"
                  cy="22"
                  r="22"
                  fill={contestDetails?.buttonColor}
                />
                <path
                  d="M17.3333 10.6665L30.6666 22.0037L17.3333 33.3332V10.6665Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="text-small-medium text-[#EAF0FF] text-left ml-[5px]">
              Watch this video to see
              <br />
              How to Participate
            </p>
          </div>
        ) : details?.howToParticipate?.files?.length == 1 ? (
          <div
            className={styles.howToParticipateCard}
            onClick={() => {
              setHowToParticipatePopup(true);
              setHowToParticipateVideo(
                details?.howToParticipate?.files[0].fileUrl
              );
            }}
          >
            <div className="w-[40px] h-[40px] shrink-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                className="w-full h-full"
              >
                <circle
                  cx="22"
                  cy="22"
                  r="22"
                  fill={contestDetails?.buttonColor}
                />
                <path
                  d="M17.3333 10.6665L30.6666 22.0037L17.3333 33.3332V10.6665Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="text-small-medium text-[#EAF0FF] text-left ml-[5px]">
              Watch this video to see
              <br />
              How to Participate
            </p>
          </div>
        ) : (
          <div className={styles.howToParticipateCard}>
            <div className="w-full">
              <p className="text-small-medium text-[#EAF0FF] text-center">
                Watch this video to see
                <br />
                How to Participate
              </p>
              <div className="w-full flex items-center justify-center gap-[8px]">
                {details?.howToParticipate?.files?.map((obj, index) => (
                  <div
                    className="px-[10px] pt-[10px] flex flex-col items-center gap-[5px]"
                    onClick={() => {
                      setHowToParticipatePopup(true);
                      setHowToParticipateVideo(obj?.fileUrl);
                    }}
                  >
                    <div className="w-[40px] h-[40px] shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="44"
                        height="44"
                        viewBox="0 0 44 44"
                        fill="none"
                        className="w-full h-full"
                      >
                        <circle
                          cx="22"
                          cy="22"
                          r="22"
                          fill={contestDetails?.buttonColor}
                        />
                        <path
                          d="M17.3333 10.6665L30.6666 22.0037L17.3333 33.3332V10.6665Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p className="text-small-medium text-[#EAF0FF] text-center ">
                      {obj?.displayText}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
